import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Input, Button, Spin, Card, Col, Row } from "antd";
import Cookies from "js-cookie";
import { useUserPermissions } from "../../../UserPermissionsContext";
import { all_routes } from "../../../router/all_routes";
import { Toast } from "react-bootstrap";

type Student = {
  SCS_Number: string;
  name: string;
  admission_status_name: string;
  state_name: string;
  zone_name: string;
  branch_name: string;
  orientation_name: string;
  student_class_name: string;
  is_wizklub_paid_last_year: boolean;
  is_wizklub_paid: boolean;
  academic_year:string;
};

const SmsToStudent = () => {
  const routes = all_routes;
  const navigate = useNavigate();
  const jwtToken = Cookies.get("authToken");
  const { userPermissions, webApi } = useUserPermissions();
  const [isLoading, setIsLoading] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState("");
  const [toastMessage, setToastMessage] = useState("");
  const [message, setMessage] = useState("");
  const [showSolidDangerToast, setShowSolidDangerToast] = useState(false);
  const [students, setStudents] = useState<Student[]>([]);
  const handleSolidDangerToastClose = () => setShowSolidDangerToast(false);
  const checkPermission = (action: any, subject: any) => {
    return userPermissions.some(
      (ability) => ability.action === action && ability.subject === subject
    );
  };

  const options = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${jwtToken}`,
    },
  };

  useEffect(() => {
    if (!checkPermission("get_students_by_phone_number", "student")) {
      navigate(routes.crmLandingPage);
    }
  }, [userPermissions]);

  useEffect(() => {
      setTimeout(() => {
        setShowSolidDangerToast(false);
        setToastMessage("")
      }, 3000);
    }, [toastMessage]);

  const handleSearch = async () => {
    // if (phoneNumber.length !== 10 || isNaN(Number(phoneNumber))) {
    //   setToastMessage("Please enter a valid 10-digit phone number.");
    //   setShowSolidDangerToast(true);
    //   return;
    // }
    setIsLoading(true);
    try {
      const response = await fetch(
        `${webApi}/sms/send_sms_custom_number/?phonenumber=${phoneNumber}`, options
      );
      if (!response.ok) {
        const errorData = await response.json();
        if (errorData.code === "token_not_valid") {
        navigate("/academic/sri-chaitanya/crm/landing-page");
      }
        setToastMessage(errorData.message);
        setShowSolidDangerToast(true);
        setMessage("");
        // throw new Error("Network response was not ok");
      }
      const data = await response.json();
      setStudents(data);
      setMessage("SMS sent successfully.");
    } catch (error) {
      console.error("Error fetching student details:", error);
      // alert("Failed to fetch student details. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="page-wrapper">
      <div className="content">
        {/* Page Header */}
        <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
          <div className="my-auto mb-2">
            <h3 className="page-title mb-1">Phone Number To Sms</h3>
            <nav>
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <Link to={routes.adminDashboard}>Dashboard</Link>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                 Phone Number To Sms
                </li>
              </ol>
            </nav>
          </div>
        </div>
        {/* Search Input */}
        <div className="mb-4">
          <Input
            placeholder="Enter 10-digit phone number"
            maxLength={10}
            value={phoneNumber}
            onChange={(e) => setPhoneNumber(e.target.value)}
            style={{ width: "300px", marginRight: "10px" }}
          />
          <Button type="primary" onClick={handleSearch}>
            Send SMS
          </Button>
        </div>
        {/* Loader or Cards */}
        {isLoading ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100px",
            }}
          >
            <Spin />
          </div>
        ) : (
          <p className="">{message}</p>
        )}
      </div>
      <Toast
        show={showSolidDangerToast}
        onClose={handleSolidDangerToastClose}
        id="solidDangerToast"
        className="colored-toast bg-danger text-fixed-white"
        role="alert"
        aria-live="assertive"
        aria-atomic="true"
        style={{
          position: "fixed",
          top: "20px",
          right: "20px",
          zIndex: 1050,
        }}
      >
        <Toast.Body>{toastMessage}</Toast.Body>
      </Toast>
    </div>
  );
};

export default SmsToStudent;
